var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user != null)?_c('v-container',{attrs:{"fluid":""}},[_c('user-edit-fields',{attrs:{"type":"edit"},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }